/**
 * HOB Article – infobox (share, like) + Table of Contents
 * Loaded only on article page via hob-article-infobox section.
 * TOC collects headings from all [data-toc-content] roots (DOM order).
 */
(function() {
  function slugify(text) {
    return text
      .trim()
      .toLowerCase()
      .replace(/[^\p{L}\p{N}\s-]/gu, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || 'section';
  }

  function ensureUniqueId(prefix, used) {
    var id = prefix;
    var n = 1;
    while (used[id]) {
      id = prefix + '-' + n;
      n++;
    }
    used[id] = true;
    return id;
  }

  function initToc() {
    var listEl = document.querySelector('.js-article-toc-list');
    var listWrap = document.querySelector('.js-article-toc-list-wrap');
    var emptyEl = document.querySelector('.js-article-toc-empty');
    var toggleBtn = document.querySelector('.js-article-toc-toggle');
    var toggleText = document.querySelector('.js-article-toc-toggle-text');
    if (!listEl) return;

    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-toc-content]'));
    var headings = [];
    roots.forEach(function(root) {
      var nodes = root.querySelectorAll('h2, h3, h4');
      for (var i = 0; i < nodes.length; i++) {
        headings.push(nodes[i]);
      }
    });

    var usedIds = {};
    headings.forEach(function(h) {
      var text = (h.textContent || '').trim();
      if (!text) return;
      var base = slugify(text);
      var id = ensureUniqueId(base, usedIds);
      h.id = id;
      if (!h.hasAttribute('tabindex')) {
        h.setAttribute('tabindex', '-1');
      }
    });

    listEl.innerHTML = '';
    if (headings.length === 0) {
      if (emptyEl) emptyEl.style.display = '';
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';

    headings.forEach(function(h) {
      var tag = h.tagName.toLowerCase();
      var id = h.id;
      var text = (h.textContent || '').trim();
      if (!id || !text) return;
      var li = document.createElement('li');
      li.className = 'hob-article-toc__item--' + tag;
      var a = document.createElement('a');
      a.href = '#' + id;
      a.className = 'hob-article-toc__link';
      a.textContent = text;
      a.addEventListener('click', function(e) {
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (history.replaceState) {
            history.replaceState(null, null, '#' + id);
          }
        }
      });
      li.appendChild(a);
      listEl.appendChild(li);
    });

    if (toggleBtn && listWrap) {
      var section = toggleBtn.closest('.hob-article-toc');
      var labelExpand = (section && section.getAttribute('data-label-expand')) || 'Inklappen';
      var labelCollapse = (section && section.getAttribute('data-label-collapse')) || 'Uitklappen';

      toggleBtn.addEventListener('click', function() {
        var collapsed = section.classList.toggle('is-collapsed');
        toggleBtn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        if (toggleText) toggleText.textContent = collapsed ? labelCollapse : labelExpand;
      });
    }
  }

  function init() {
    // Share: copy link to clipboard (Instagram + copy-link buttons)
    document.querySelectorAll('.js-share-copy').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var url = window.location.href;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function() {
            var label = btn.getAttribute('aria-label') || 'Link gekopieerd';
            btn.setAttribute('aria-label', 'Link gekopieerd');
            setTimeout(function() {
              btn.setAttribute('aria-label', label);
            }, 2000);
          });
        } else {
          var ta = document.createElement('textarea');
          ta.value = url;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try {
            document.execCommand('copy');
            btn.setAttribute('aria-label', 'Link gekopieerd');
          } catch (e) {}
          document.body.removeChild(ta);
        }
      });
    });

    // Like button: toggle + localStorage + count display
    document.querySelectorAll('.js-article-like').forEach(function(btn) {
      var id = btn.getAttribute('data-article-id');
      if (!id) return;
      var key = 'hob_article_like_' + id;
      var wrap = btn.closest('.hob-article-infobox__like-wrap');
      var countEl = wrap ? wrap.querySelector('.js-article-like-num') : null;
      var countWrap = wrap ? wrap.querySelector('.js-article-like-count') : null;

      function updateCount() {
        var isLiked = btn.classList.contains('is-liked');
        var num = isLiked ? 1 : 0;
        if (countEl) countEl.textContent = num;
        if (countWrap) {
          countWrap.classList.toggle('has-likes', isLiked);
          var ariaBase = countWrap.getAttribute('data-aria-label') || 'Aantal likes';
          countWrap.setAttribute('aria-label', ariaBase + ': ' + num);
        }
      }

      if (localStorage.getItem(key) === '1') btn.classList.add('is-liked');
      updateCount();
      btn.addEventListener('click', function() {
        btn.classList.toggle('is-liked');
        localStorage.setItem(key, btn.classList.contains('is-liked') ? '1' : '0');
        updateCount();
      });
    });

    initToc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
